import { css } from '@emotion/css';

import { globalNavMenuButtonClassName } from '../../components/GlobalHeader/GlobalHeader.constants';
import { m } from '../m';

export const snapHeaderCss = css`
  /**
   * Hide the header item indicator on the snap.com home page header item hover state
   */
  &:hover span::after {
    display: none;
  }

  /**
   * Override motif styles for IconButton used in snap.com home page Header to match design specs
   */
  && .${globalNavMenuButtonClassName} {
    border: none;
    box-shadow: none;
    padding: 0;
    margin-right: ${m('--spacing-xs')};
    margin-left: calc(-1 * ${m('--spacing-xs')});

    *[dir='rtl'] & {
      margin-right: calc(-1 * ${m('--spacing-xs')});
      margin-left: ${m('--spacing-xs')};
    }
  }

  /**
   * Snap.com home page specific styles for nav element inside the Global Header
   */
  & nav {
    gap: ${m('--spacing-m')};

    /**
     * Remove right margin from the last nav link on snap.com home page header
     */
    & a:last-child {
      margin-right: 0;
    }
  }
`;
